import React, {useContext} from 'react';
import {injectIntl} from "react-intl";
import SelectField from "@FormElements/SelectField";
import FormContext from "formContext";

function BranchSelectField({intl, settings, ...rest}) {
  const {additionalData, currentStep, formData} = useContext(FormContext);

  if (!formData || !formData[currentStep] || !formData[currentStep]['specialism'] || !formData[currentStep]['can_select_branch'] || !additionalData.branches || !additionalData.branches.length) {
    return '';
  }
  else {
    settings.options = [{
      value: '',
      label: intl.formatMessage({id: 'SelectField.EmptyOption.Label'})
    }];

    additionalData.branches.forEach(branch => {
      settings.options.push({
        value: branch.value,
        label: branch.label
      })
    })
  }

  return (
    <SelectField
      settings={settings}
      {...rest}
    />
  )

}

export default injectIntl(BranchSelectField);
